export const SET_RESTORE = 'SET_RESTORE';
export const SET_RESET = 'SET_RESET';
export const SET_NOWLISTID = 'SET_NOWLISTID';
export const SET_NOWLISTDATA = 'SET_NOWLISTDATA';
export const SET_DETAILDATA = 'SET_DETAILDATA';
export const SET_TICKECTNUM = 'SET_TICKECTNUM';
export const SET_TOTALAMOUNT = 'SET_TOTALAMOUNT';
export const SET_TEMPCALENDARDATA = 'SET_TEMPCALENDARDATA';
export const SET_PICKCALENDAR = 'SET_PICKCALENDAR';
export const SET_ISDETAILLOADING = 'SET_ISDETAILLOADING';
export const SET_DETAILLOADINGFAIL = 'SET_DETAILLOADINGFAIL';
export const SET_ISSESSIONLOADING = 'SET_ISSESSIONLOADING';
export const SET_SESSIONLOADINGFAIL = 'SET_SESSIONLOADINGFAIL';
export const SET_CALENDARERRORMSG = 'SET_CALENDARERRORMSG';
export const SET_SESSIONERRORMSG = 'SET_SESSIONERRORMSG';
export const SET_TICKETERRORMSG = 'SET_TICKETERRORMSG';
export const SET_SCROLLTO = 'SET_SCROLLTO';
export const SET_SUBMITWATCHER = 'SET_SUBMITWATCHER';
export const SET_ISSUBMITSUCCESS = 'SET_ISSUBMITSUCCESS';
// 自建
export const SET_OPENNVBRSLB = 'SET_OPENNVBRSLB';
export const SET_ALLSESSIONS = 'SET_ALLSESSIONS';
export const SET_DISABLEDSESSIONS = 'SET_DISABLEDSESSIONS';
export const SET_PICKSESSION = 'SET_PICKSESSION';
export const SET_DISABLEDDATEBYSESSION = 'SET_DISABLEDDATEBYSESSION';
export const SET_MINDATE = 'SET_MINDATE';
export const SET_NULLDATE = 'SET_NULLDATE';
export const SET_DISABLEDDATE = 'SET_DISABLEDDATE';
export const SET_SOLDOUTDATE = 'SET_SOLDOUTDATE';
export const SET_ETITEMDATA = 'SET_ETITEMDATA';
/*
// GDS
export const SET_GRESTORE = 'SET_GRESTORE';
export const SET_GRESET = 'SET_GRESET';
export const SET_CALENDAR = 'SET_CALENDAR';
export const SET_GTICKECTNUM = 'SET_GTICKECTNUM';
export const SET_GSESSION = 'SET_GSESSION';
export const SET_GSESSIONPICKED = 'SET_GSESSIONPICKED';
export const SET_GTOTALAMOUNT = 'SET_GTOTALAMOUNT';
export const SET_GDETAIL = 'SET_GDETAIL';
export const SET_GTEMPCALENDARDATA = 'SET_GTEMPCALENDARDATA';
export const SET_GCALENDARREF = 'SET_GCALENDARREF';
export const SET_ISGDSDETAILLOADING = 'SET_ISGDSDETAILLOADING';
export const SET_GDSDETAILFETCHFAIL = 'SET_GDSDETAILFETCHFAIL';
export const SET_ISGDSSESSIONLOADING = 'SET_ISGDSSESSIONLOADING';
export const SET_GDSSESSIONFETCHFAIL = 'SET_GDSSESSIONFETCHFAIL';
export const SET_GNOWLIST = 'SET_GNOWLIST';
export const SET_GNOWLISTDATA = 'SET_GNOWLISTDATA';
export const SET_GCALENDARERR = 'SET_GCALENDARERR';
export const SET_GSESSIONERR = 'SET_GSESSIONERR';
export const SET_GTICKETERR = 'SET_GTICKETERR';
export const SET_GSCROLLTO = 'SET_GSCROLLTO';
export const SET_GSUBMITWATCHER = 'SET_GSUBMITWATCHER';
export const SET_ISGSUBMITSUCCESS = 'SET_ISGSUBMITSUCCESS';
*/
